// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"433":"css/app.6707","6779":"css/admin-app.6707"}[chunkId] + ".css";
};